'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.RESET = exports.setWidth = exports.SET_WIDTH = exports.setSizeArr = exports.setSize = exports.SET_SIZE = exports.setRem = exports.SET_REM = exports.setId = exports.SET_ID = exports.setHeight = exports.SET_HEIGHT = undefined;

var _spread2 = require('lodash/spread');

var _spread3 = _interopRequireDefault(_spread2);

var _capeRedux = require('cape-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_HEIGHT = exports.SET_HEIGHT = 'windowsize/SET_HEIGHT';
var setHeight = exports.setHeight = (0, _capeRedux.createSimpleAction)(SET_HEIGHT);

// setId('Large')
var SET_ID = exports.SET_ID = 'windowsize/SET_ID';
var setId = exports.setId = (0, _capeRedux.createSimpleAction)(SET_ID);

// setRem(16) or setRem(16px)
var SET_REM = exports.SET_REM = 'windowsize/SET_REM';
var setRem = exports.setRem = (0, _capeRedux.createSimpleAction)(SET_REM, parseFloat);

// setSize(height, width)
var SET_SIZE = exports.SET_SIZE = 'windowsize/SET_SIZE';
var setSize = exports.setSize = (0, _capeRedux.createSimpleAction)(SET_SIZE, function (height, width) {
  return { height: height, width: width };
});
var setSizeArr = exports.setSizeArr = (0, _spread3.default)(setSize);

var SET_WIDTH = exports.SET_WIDTH = 'windowsize/SET_WIDTH';
var setWidth = exports.setWidth = (0, _capeRedux.createSimpleAction)(SET_WIDTH);

var RESET = exports.RESET = 'windowsize/RESET';
var reset = exports.reset = (0, _capeRedux.noopAction)(RESET);


//////////////////
// WEBPACK FOOTER
// ./~/redux-windowsize/lib/actions.js
// module id = 293
// module chunks = 0